import { render } from "./GroupsView.vue?vue&type=template&id=2dd72920&scoped=true"
import script from "./GroupsView.vue?vue&type=script&lang=js"
export * from "./GroupsView.vue?vue&type=script&lang=js"

import "./GroupsView.vue?vue&type=style&index=0&id=2dd72920&lang=scss&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd72920"]])

export default __exports__